'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('ramda/src/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _templateObject = _taggedTemplateLiteral(['height:', ';padding:0 15px;display:flex;align-items:center;cursor:pointer;text-decoration:none;color:', ';transition:color cubic-bezier(0.47,0,0.75,0.72) 0.3s;cursor:', ';&:hover{color:', ';}path{fill:currentColor;}'], ['height:', ';padding:0 15px;display:flex;align-items:center;cursor:pointer;text-decoration:none;color:', ';transition:color cubic-bezier(0.47,0,0.75,0.72) 0.3s;cursor:', ';&:hover{color:', ';}path{fill:currentColor;}']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var omitProps = (0, _omit3.default)(['active', 'disabled']);

var BaseComponent = function BaseComponent(_ref) {
  var component = _ref.component,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['component', 'children']);

  return _react2.default.createElement(component, omitProps(otherProps), children);
};
BaseComponent.displayName = 'BaseComponent';
BaseComponent.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
  children: _propTypes2.default.node.isRequired
};
var NavItem = (0, _styledComponents2.default)(BaseComponent)(_templateObject, function (props) {
  return props.theme.height.header;
}, function (props) {
  return props.active ? props.theme.color.black : props.theme.color.grayDark;
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled ? props.theme.color.grayDark : props.theme.color.black;
});
NavItem.displayName = 'NavItem';
NavItem.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  disabled: _propTypes2.default.bool,
  active: _propTypes2.default.bool
};
NavItem.defaultProps = {
  component: 'div',
  disabled: false,
  active: false
};

exports.default = NavItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/LandingHeader/NavItem.js
// module id = 77
// module chunks = 4